import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Loading from 'components/shared-components/Loading';
import { AUTH_PREFIX_PATH } from 'configs/AppConfig';

export const AppViews = () => {
  return (
    <Suspense fallback={<Loading cover="page" />}>
      <Routes>
        <Route
          path="login"
          element={React.createElement(
            lazy(() => import(`./authentication/login`))
          )}
        />
        <Route
          path="error-1"
          element={React.createElement(
            lazy(() => import(`./errors/error-page-1`))
          )}
        />
        <Route
          path="error-2"
          element={React.createElement(
            lazy(() => import(`./errors/error-page-2`))
          )}
        />
        <Route
          path="verify"
          element={React.createElement(
            lazy(() => import(`./authentication/verify`))
          )}
        />
        <Route
          path="callback"
          element={React.createElement(lazy(() => import(`./auth-callback`)))}
        />
        <Route path="*" element={<Navigate to="login" replace />} />
      </Routes>
    </Suspense>
  );
};

export default AppViews;
